import { createContext } from "react"

const BankPricesReferenceContext = createContext()

export default BankPricesReferenceContext
